<template>
  <div>
    <Header />
      <FlashMessage ref="flashMessage" />

    <div class="checkout-page">
        <LoadingIndicator v-if="loading" message="Loading ..." />

      <h1>Checkout</h1>

      <!-- Order Summary -->
      <div class="order-summary">
        <h2>Order Summary</h2>
        <div class="order-items">
          <div class="order-item" v-for="item in cartItems" :key="item.id">
            <img
              :src="getFullImageUrl(item.product.thumbnail)"
              :alt="item.product.name"
              class="item-image"
            />
            <div class="item-details">
              <h3>{{ item.name }}</h3>
              <p>Quantity: {{ item.quantity }}</p>
              <p>Price: Tsh:{{ item.price }}</p>
            </div>
          </div>
        </div>
        <div class="order-total">
          <p>
            Subtotal: <span>Tsh:{{ subtotal }}</span>
          </p>
          <p>
            Shipping: <span>Tsh:{{ shippingCost }}</span>
          </p>
          <p>
            Taxes: <span>Tsh:{{ taxes }}</span>
          </p>
          <p class="total">
            Total: <span>Tsh:{{ totalAmount }}</span>
          </p>
        </div>
      </div>

      <!-- Shipping Address -->
      <div class="shipping-address">
        <h2>Shipping Address</h2>
        <form @submit.prevent="placeOrder">
          <div class="form-group">
            <label for="fullAddress ">Full Adress</label>
            <input
              type="text"
              id="fullAddress "
              v-model="shippingAddress.fullAddress"
              required
              placeholder="eg:- Mawasiliano-ubungo-Dar es salaam"
            />
          </div>

        <!-- if user choose to pay with mobile money transfer -->
          <div class="form-group" v-if="ismobiletransfer">
            <label for="fullAddress ">Recharge Phone</label>
            <input
              type="tel"
              id="rechargePhone "
              v-model="shippingAddress.rechargePhone"
              required
              placeholder="eg:- 0745000000"
            />
          </div>




        <div v-if="isBankTransfer">

          <div class="form-group">
            <label>Billing City</label>

            <input
              type="text"
              v-model="shippingAddress.billingCity"
              placeholder="Dar es Salaam"
            />
          </div>

          <div class="form-group">
            <label>State / Region</label>

            <input
              type="text"
              v-model="shippingAddress.billingState"
              placeholder="DSM"
            />
          </div>

          <div class="form-group">
            <label>Postcode</label>

            <input
              type="text"
              v-model="shippingAddress.billingPostCode"
              placeholder="00000"
            />
          </div>

          <div class="form-group">
            <label>Country</label>

            <input
              type="text"
              v-model="shippingAddress.billingCountry"
              placeholder="TZ"
            />
          </div>

        </div>


                <!-- Payment Method -->
          <div class="payment-method">
            <h2>Payment Method</h2>

            <div class="payment-grid">
              <div
                class="payment-options"
                v-for="method in paymentMethods"
                :key="method.id"
              >
                <label
                  :class="{
                    activePayment: appliedpaymentMethod === method.id
                  }"
                >
                  <input
                    type="radio"
                    name="paymentMethod"
                    :value="method.id"
                    v-model="appliedpaymentMethod"
                    @change="checkSelectedPaymentMethod(method.name)"
                  />

                  <span>{{ method.name }}</span>
                </label>
              </div>
            </div>
          </div>

            <button class="place-order-btn">Place Order</button>

        </form>

      <div class="payment-methods">
        <h3>Supported Payment Methods</h3>

        <div class="payment-grid">
          <div class="payment-item">
            <img :src="mobileImg" alt="Mobile Payment" />
            <!-- <span>Mobile Money</span> -->
          </div>
        </div>
      </div>

      </div>

      <!-- Discount or Promo Code -->
      <!-- <div class="discount-code">
        <h2>Discount Code</h2>
        <div class="discount-input">
          <input
            type="text"
            placeholder="Enter promo code"
            v-model="promoCode"
          />
          <button @click="applyPromoCode">Apply</button>
        </div>
      </div> -->

      <!-- Place Order Button -->
    </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";

import Header from "../components/Header.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import LoadingIndicator from "@/components/Loading_indicator.vue";

import mobileImg from "@/assets/img/mobile_transfer.jpeg";

import {
  GetCartData,
  API_BASE_URL,
  GetPaymentMethods,
  CheckoutOrder,
} from "../API-requests/Requests";

// router
const router = useRouter();

// UI states
const cartItems = ref([]);
const paymentMethods = ref([]);
const loading = ref(false);
const error = ref(null);
const flashMessage = ref(null);

// payment method states
const ismobiletransfer = ref(false);
const isCashOnDelivery = ref(false);
const isBankTransfer = ref(false);

// form states
const shippingAddress = ref({
  fullAddress: "",
  rechargePhone: "",

  // billing details for card/bank checkout
  billingCity: "",
  billingState: "",
  billingPostCode: "",
  billingCountry: "Tanzania",
});

// selected payment method
const appliedpaymentMethod = ref("");

// detect payment method type
const checkSelectedPaymentMethod = (selectedMethod) => {

  // reset all states
  ismobiletransfer.value = false;
  isCashOnDelivery.value = false;
  isBankTransfer.value = false;

  // mobile money
  if (
    [
      "M-Pesa",
      "Airtel Money",
      "Mix By Yas",
      "T-PESA",
      "Halo Pesa",
    ].includes(selectedMethod)
  ) {
    ismobiletransfer.value = true;
  }

  // cash
  else if (selectedMethod === "Cash") {
    isCashOnDelivery.value = true;
  }

  // card/bank
  else if (selectedMethod === "Card") {
    isBankTransfer.value = true;
  }
};

// cart calculations
const subtotal = computed(() => {
  return cartItems.value.reduce(
    (t, i) => t + i.price * i.quantity,
    0
  );
});

const shippingCost = computed(() => {
  return subtotal.value > 50000 ? 0 : 0;
});

const taxes = computed(() => {
  return 0;
});

const totalAmount = computed(() => {
  return subtotal.value + shippingCost.value + taxes.value;
});

// checkout logic
const placeOrder = async () => {

  try {

    loading.value = true;

    // shipping validation
    if (!shippingAddress.value.fullAddress) {

      flashMessage.value?.showFlashMessage(
        "failure",
        "Shipping address is required"
      );

      return;
    }

    // payment method validation
    if (!appliedpaymentMethod.value) {

      flashMessage.value?.showFlashMessage(
        "failure",
        "Please select payment method"
      );

      return;
    }

    // mobile recharge validation
    if (
      ismobiletransfer.value &&
      !shippingAddress.value.rechargePhone
    ) {

      flashMessage.value?.showFlashMessage(
        "error",
        "Recharge phone is required"
      );

      return;
    }

    // card/bank validations
    if (isBankTransfer.value) {

      if (
        !shippingAddress.value.billingCity ||
        !shippingAddress.value.billingState ||
        !shippingAddress.value.billingPostCode ||
        !shippingAddress.value.billingCountry
      ) {

        flashMessage.value?.showFlashMessage(
          "error",
          "Please fill all billing details"
        );

        return;
      }
    }

    // payload
    const payload = {

      shipping_address:
        shippingAddress.value.fullAddress,

      recharge_phone_number:
        shippingAddress.value.rechargePhone,

      payment_method_id:
        appliedpaymentMethod.value,

      // billing details
      billing_city:
        shippingAddress.value.billingCity,

      billing_state_or_region:
        shippingAddress.value.billingState,

      billing_postcode_or_pobox:
        shippingAddress.value.billingPostCode,

      billing_country:
        shippingAddress.value.billingCountry,
    };

    // API request
    const response = await CheckoutOrder(payload);

    console.log("CHECKOUT RESPONSE:", response);

    // success flash
    flashMessage.value?.showFlashMessage(
      "success",
      response.message || "Order placed successfully!"
    );

    // applied payment method
    const appliedMethod = response.applied_p_method;

    // =========================
    // CARD / BANK FLOW
    // =========================
    if (
      appliedMethod === "Card" &&
      response.payment?.checkout_url
    ) {

      setTimeout(() => {

        // redirect to payment page
        window.location.href =
          response.payment.checkout_url;

      }, 1500);

      return;
    }

    // =========================
    // NORMAL FLOW
    // =========================
    setTimeout(() => {
      router.push("/order");
    }, 2000);

  } catch (err) {

    console.error(err);

    flashMessage.value?.showFlashMessage(
      "failure",
      err.response?.data?.message ||
      err.message ||
      "Failed to create order"
    );

  } finally {

    loading.value = false;
  }
};

// load cart
const fetchCart = async () => {

  try {

    const res = await GetCartData();
    cartItems.value = res.cart_items || [];

  } catch (err) {

    console.error(err);
  }
};

// load payment methods
const fetchPayments = async () => {

  try {

    const res = await GetPaymentMethods();
    paymentMethods.value = res.paymentmethods || [];

  } catch (err) {

    console.error(err);
  }
};

onMounted(() => {
  fetchCart();
  fetchPayments();
});

// image helper
const getFullImageUrl = (path) => {
  return `${API_BASE_URL}${path}`;
};
</script>
<style scoped>

/* =========================
   GLOBAL LAYOUT
========================= */

.checkout-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
}

.checkout-page h1 {
  font-size: 2rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 24px;
}

/* =========================
   SECTION CARDS
========================= */

.order-summary,
.shipping-address,
.payment-method,
.discount-code,
.card-payment-section {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  padding: 24px;
  margin-bottom: 24px;

  box-shadow:
    0 4px 12px rgba(15, 23, 42, 0.04);
}

.order-summary h2,
.shipping-address h2,
.payment-method h2,
.discount-code h2,
.payment-section-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #0f172a;
  margin-bottom: 22px;
}

/* =========================
   ORDER ITEMS
========================= */

.order-items {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.order-item {
  display: flex;
  align-items: center;
  gap: 16px;

  padding-bottom: 14px;
  border-bottom: 1px solid #f1f5f9;
}

.order-item:last-child {
  border-bottom: none;
}

.order-item img {
  width: 70px;
  height: 70px;
  border-radius: 12px;
  object-fit: cover;
}

.item-details h3 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: #0f172a;
}

.item-details p {
  margin-top: 4px;
  color: #64748b;
  font-size: 0.95rem;
}

/* =========================
   ORDER TOTALS
========================= */

.order-total {
  margin-top: 22px;
  padding-top: 18px;
  border-top: 1px solid #e2e8f0;
}

.order-total p {
  display: flex;
  justify-content: space-between;

  margin: 10px 0;

  font-size: 0.98rem;
  color: #334155;
}

.order-total .total {
  font-size: 1.2rem;
  font-weight: 700;
  color: #2563eb;
}

/* =========================
   FORMS
========================= */

.form-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: span 2;
}

.form-group label {
  margin-bottom: 8px;

  font-size: 0.95rem;
  font-weight: 600;

  color: #334155;
}

.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;

  padding: 14px 15px;

  border-radius: 12px;
  border: 1px solid #cbd5e1;

  font-size: 0.96rem;

  background: #fff;

  transition: all 0.2s ease;
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
}

.form-group input:focus,
.form-group textarea:focus,
.form-group select:focus {
  outline: none;

  border-color: #2563eb;

  box-shadow:
    0 0 0 4px rgba(37, 99, 235, 0.12);
}

/* =========================
   PAYMENT METHODS
========================= */

.payment-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.payment-options label {
  display: flex;
  align-items: center;
  gap: 12px;

  padding: 16px;

  border-radius: 14px;
  border: 1px solid #dbe2ea;

  background: #fff;

  cursor: pointer;

  transition: all 0.25s ease;
}

.payment-options label:hover {
  border-color: #2563eb;
  background: #f8fbff;

  transform: translateY(-2px);
}

.payment-options input[type="radio"] {
  width: 18px;
  height: 18px;

  accent-color: #2563eb;
}

.payment-options span {
  font-size: 0.96rem;
  font-weight: 500;
  color: #1e293b;
}

.activePayment {
  border-color: #2563eb !important;
  background: #eff6ff !important;
}

/* =========================
   MOBILE PAYMENT THUMBNAILS
========================= */

.payment-methods {
  margin-top: 24px;
}

.payment-methods h3 {
  font-size: 1.1rem;
  margin-bottom: 16px;
  color: #0f172a;
}

.payment-item {
  background: #ffffff;

  border: 1px solid #e2e8f0;
  border-radius: 14px;

  padding: 14px;

  text-align: center;

  transition: all 0.25s ease;
}

.payment-item:hover {
  transform: translateY(-3px);

  box-shadow:
    0 8px 20px rgba(15, 23, 42, 0.08);
}

.payment-item img {
  width: 100%;
  max-height: 70px;
  object-fit: contain;

  margin-bottom: 10px;
}

.payment-item span {
  font-size: 0.9rem;
  font-weight: 500;
  color: #334155;
}

/* =========================
   DISCOUNT
========================= */

.discount-input {
  display: flex;
  gap: 12px;
}

.discount-input input {
  flex: 1;
}

.discount-input button {
  padding: 14px 22px;

  border: none;
  border-radius: 12px;

  background: #2563eb;
  color: #fff;

  font-size: 0.95rem;
  font-weight: 600;

  cursor: pointer;

  transition: all 0.25s ease;
}

.discount-input button:hover {
  background: #1d4ed8;
}

/* =========================
   PLACE ORDER BUTTON
========================= */

.place-order-btn {
  width: 100%;

  padding: 16px;

  border: none;
  border-radius: 14px;

  background: linear-gradient(
    135deg,
    #2563eb,
    #1d4ed8
  );

  color: #ffffff;

  font-size: 1rem;
  font-weight: 600;

  cursor: pointer;

  transition: all 0.25s ease;
}

.place-order-btn:hover {
  transform: translateY(-2px);

  box-shadow:
    0 10px 22px rgba(37, 99, 235, 0.2);
}

.place-order-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* =========================
   RESPONSIVE
========================= */

@media (max-width: 992px) {

  .payment-grid,
  .form-grid {
    grid-template-columns: 1fr;
  }

  .form-group.full-width {
    grid-column: span 1;
  }
}

@media (max-width: 768px) {

  .checkout-page {
    padding: 16px;
  }

  .checkout-page h1 {
    font-size: 1.6rem;
  }

  .order-summary,
  .shipping-address,
  .payment-method,
  .discount-code,
  .card-payment-section {
    padding: 18px;
    border-radius: 16px;
  }

  .payment-options label {
    padding: 14px;
  }

  .discount-input {
    flex-direction: column;
  }

  .order-item {
    align-items: flex-start;
  }

  .order-item img {
    width: 60px;
    height: 60px;
  }
}

@media (max-width: 480px) {

  .checkout-page h1 {
    font-size: 1.4rem;
  }

  .order-summary h2,
  .shipping-address h2,
  .payment-method h2,
  .discount-code h2,
  .payment-section-title {
    font-size: 1.1rem;
  }

  .place-order-btn {
    font-size: 0.95rem;
  }
}

</style>
